export default "__VITE_ASSET__COH_UUkm__"